import type {QueryFunctionContext, UseQueryOptions} from '@tanstack/react-query'
import {queryOptions, useQuery} from '@tanstack/react-query'

import type {SupportedLocales} from '@/lib/locale/locale'
import type {Reward} from '@/models/rewardModel'
import {getReferrer, getRewards} from '@/services/rewardService'

// Rewards query
export function getRewardsQueryKey(params: {locale: SupportedLocales}) {
  return ['rewards', params.locale] as const
}

export function getRewardsQueryOptions<TData = Reward[], TError = Error>(
  params: {
    locale: SupportedLocales
  },
  options?: Omit<UseQueryOptions<Reward[], TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getRewardsQueryKey(params),
    queryFn: async ({signal}: QueryFunctionContext) => {
      return await getRewards({signal, locale: params.locale})
    },
    ...options,
  })
}

export function useRewards(locale: SupportedLocales) {
  return useQuery(
    getRewardsQueryOptions({
      locale,
    }),
  )
}

// Referrer query
export function getReferrerQueryKey() {
  return ['referrer'] as const
}

export function getReferrerQueryOptions<TData = boolean, TError = Error>(
  options?: Omit<UseQueryOptions<boolean, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getReferrerQueryKey(),
    queryFn: async ({signal}: QueryFunctionContext) => {
      return await getReferrer({signal})
    },
    ...options,
  })
}

export function useReferrer() {
  return useQuery(getReferrerQueryOptions())
}
